import React, { useState } from "react";
import { useFetchReviews } from "hooks/Reviews/useFetchReviews";
import StarRatingComponent from "react-star-rating-component";
import Pagination from "./pagination";

export default function AllReviews() {
  const orangeColor = "#FF7B16";
  const [pageNumber, setpageNumber] = useState(1);
  const { data } = useFetchReviews(pageNumber);

  return (
    <div className="bg-midBlue py-14">
      <div className="lg:w-8/12 w-full lg:px-0 px-4 flex flex-col justify-center mx-auto">
        <h2 className="text-white text-4xl text-center font-semibold font-secondary">
          <span className="text-orange">All </span>Reviews
        </h2>
        <p className="py-10 text-white text-center">
          Our client satisfaction rate is 98%, specifically because we put the
          client at the heart of our philosophy. These are the reviews of the
          customers who have been satisfied with our service
        </p>
        <div className="font-primary flex justify-between text-white border-b border-[#616161] pb-3">
          <div className="left flex gap-x-3 text-white pt-4 font-primary">
          {pageNumber > 1 ? (
            <a role="button" onClick={() => setpageNumber((page) => page - 1)}>
              Previous
            </a>
          ) : (
            <></>
          )}

          <a role="button" style={{ color: pageNumber ? orangeColor : "" }}>
            {pageNumber}
          </a>
          { (data?.meta.last_page !== data?.meta.current_page)  && <>
            <a
              role="button"
              onClick={() => setpageNumber((page) => page + 1)}
            >
              {pageNumber + 1}
            </a>
            
            {  (data?.meta.last_page-1 !== data?.meta.current_page)  && <>
              <a
                role="button"
                onClick={() => setpageNumber((page) => page + 2)}
              >
                {pageNumber + 2}
              </a>
              </>}
          </>}
          { (data?.meta?.last_page - data?.meta?.current_page) > 3 && <>
          .
          .
          .
          <a
            role="button"
            style={{
              color: data?.meta?.current_page === data?.meta.last_page ? orangeColor : "",
            }}
            onClick={() => setpageNumber((page) => data?.meta.last_page)}
          >
            {data?.meta.last_page}
          </a>
          </>}
          {pageNumber < data?.meta.last_page-2 && 
          <a role="button" onClick={() => setpageNumber((page) => page + 1)}>
            Next
          </a>
          }
          </div>
          <div className="right flex items-center">
            {/* <label htmlFor="" className="pr-2">
              Sort by:
            </label>
            <select name="select me" id="" className="bg-[#3498DB] px-3 py-2">
              <option value="first">Date</option>
              <option value="second">Industry</option>
            </select> */}
          </div>
        </div>
        {data?.data.map((r, i) => {
          return (
            <div
              className="comment text-white border-b border-[#616161] py-10"
              key={i}
            >
              <h1>
                <a href={r.link} target="_blank">
                  {r.Name}
                </a>
                , <span className="font-semibold">{r.Company}</span>
              </h1>
              <div className="stars flex gap-x-2">
                <StarRatingComponent
                  name="rate1"
                  starCount={5}
                  value={r.rating}
                  editing={false}
                />
              </div>
              <p className="py-4">{r.Reviews}</p>
            </div>
          );
        })}
        <div className="flex gap-x-3 text-white pt-4 font-primary">
          {pageNumber > 1 ? (
            <a role="button" onClick={() => setpageNumber((page) => page - 1)}>
              Previous
            </a>
          ) : (
            <></>
          )}

          <a role="button" style={{ color: pageNumber ? orangeColor : "" }}>
            {pageNumber}
          </a>
          { (data?.meta.last_page !== data?.meta.current_page)  && <>
            <a
              role="button"
              onClick={() => setpageNumber((page) => page + 1)}
            >
              {pageNumber + 1}
            </a>
            
            {  (data?.meta.last_page-1 !== data?.meta.current_page)  && <>
              <a
                role="button"
                onClick={() => setpageNumber((page) => page + 2)}
              >
                {pageNumber + 2}
              </a>
              </>}
          </>}
          { (data?.meta?.last_page - data?.meta?.current_page) > 3 && <>
          .
          .
          .
          <a
            role="button"
            style={{
              color: data?.meta?.current_page === data?.meta.last_page ? orangeColor : "",
            }}
            onClick={() => setpageNumber((page) => data?.meta.last_page)}
          >
            {data?.meta.last_page}
          </a>
          </>}
          {pageNumber < data?.meta.last_page-2 && 
          <a role="button" onClick={() => setpageNumber((page) => page + 1)}>
            Next
          </a>
          }
          </div>
      </div>
    </div>
  );
}
